import React, { useState } from "react";
import {
  MapPin,
  X,
  User,
  Phone,
  Mail,
  ShoppingBag,
  ChevronRight
} from "lucide-react";
import LocationPicker from "../../common/LocationPicker";
import "./CheckoutModal.css";

export default function CheckoutModal({
  cart = [],
  checkoutData,
  setCheckoutData,
  onSubmit,
  onBack
}) {
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [placingOrder, setPlacingOrder] = useState(false);

  const handlePlaceOrder = async () => {

    if(placingOrder) return;

    setPlacingOrder(true);

    try{

        await onSubmit();

    }finally{

        setPlacingOrder(false);

    }

};
  const totalAmount = cart.reduce((sum, item) => {
    if (item.productType === "SALE") {
      return (
        sum +
        (Number(item.price) || 0) *
          (Number(item.quantity) || 1)
      );
    }

    return (
      sum +
      (Number(item.dailyPrice) || 0) *
        (Number(item.quantity) || 1) *
        (Number(item.days) || 1)
    );
  }, 0);

  return (
    <>
      <div
        className="checkout-backdrop"
        onClick={onBack}
      />

      <div
        className="checkout-sheet"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Handle */}

        <div className="checkout-handle" />

        {/* Header */}

        <div className="checkout-header">

          <div>

            <h2>Checkout</h2>

            <p>
              Complete your order details
            </p>

          </div>

          <button
            className="checkout-close"
            onClick={onBack}
          >
            <X size={22} />
          </button>

        </div>

        {/* Scroll Area */}

        <div className="checkout-body">

          {/* CUSTOMER */}

          <div className="checkout-card">

            <div className="checkout-card-title">

              <User size={18} />

              <span>Customer Details</span>

            </div>

            {/* Name */}

            <div className="checkout-field">

              <label>
                Customer Name
              </label>

              <input
                type="text"
                placeholder="Enter your name"
                value={checkoutData.name}
                onChange={(e) =>
                  setCheckoutData({
                    ...checkoutData,
                    name: e.target.value
                  })
                }
              />

            </div>

            {/* Phone */}

            <div className="checkout-field">

              <label>
                Mobile Number
              </label>

              <div className="checkout-input-icon">

                <Phone size={18} />

                <input
                  type="tel"
                  placeholder="Enter mobile number"
                  value={checkoutData.phone}
                  onChange={(e) =>
                    setCheckoutData({
                      ...checkoutData,
                      phone: e.target.value
                    })
                  }
                />

              </div>

            </div>

            {/* Email */}

            <div className="checkout-field">

              <label>Email</label>

              <div className="checkout-input-icon">

                <Mail size={18} />

                <input
                  type="email"
                  value={checkoutData.email}
                  readOnly
                />

              </div>

            </div>

          </div>

                    {/* ===========================
              DELIVERY LOCATION
          ============================ */}

          <div className="checkout-card">

            <div className="checkout-card-title">

              <MapPin size={18} />

              <span>Delivery Location</span>

            </div>

            <button
              className="checkout-location-card"
              onClick={() => setShowLocationModal(true)}
            >

              <div className="checkout-location-left">

                <div className="checkout-location-icon">
                  <MapPin size={20} />
                </div>

                <div>

                  <h4>
                    {checkoutData.deliveryLocation?.address
                      ? "Delivery Address"
                      : "Choose Delivery Location"}
                  </h4>

                  <p>
                    {checkoutData.deliveryLocation?.address
                      ? checkoutData.deliveryLocation.address
                      : "Tap here to pin your construction site"}
                  </p>

                </div>

              </div>

              <ChevronRight size={20} />

            </button>

            {checkoutData.deliveryLocation && (

              <div className="checkout-address-card">

                <div className="checkout-address-title">
                  Selected Address
                </div>

                <div className="checkout-address">

                  {checkoutData.deliveryLocation.address}

                </div>

                <div className="checkout-address-extra">

                  {checkoutData.deliveryLocation.city}

                  {checkoutData.deliveryLocation.city &&
                    checkoutData.deliveryLocation.state
                      ? ", "
                      : ""}

                  {checkoutData.deliveryLocation.state}

                </div>

              </div>

            )}

          </div>

          {/* ===========================
                ORDER SUMMARY
          ============================ */}

          <div className="checkout-card">

            <div className="checkout-card-title">

              <ShoppingBag size={18} />

              <span>Order Summary</span>

            </div>

            <div className="checkout-products">

              {cart.map((item) => (

                <div
                  key={item._id}
                  className="checkout-product"
                >

                  <div className="checkout-product-left">

                    <div className="checkout-product-image">

                      {item.imageUrl ? (
                        <img
                          src={item.imageUrl}
                          alt={item.name}
                        />
                      ) : (
                        <ShoppingBag size={22} />
                      )}

                    </div>

                    <div>

                      <div className="checkout-product-name">
                        {item.name}
                      </div>

                      <div className="checkout-product-code">
                        {item.vendorProductCode}
                      </div>

                      {item.productType === "SALE" ? (

                        <div className="checkout-product-meta">

                          Qty : {item.quantity}

                          {item.unit &&
                            ` • ${item.unit}`}

                          {item.size &&
                            ` • ${item.size}`}

                        </div>

                      ) : (

                        <div className="checkout-product-meta">

                          Qty : {item.quantity}

                          {" • "}

                          {item.days} Days

                          {item.size &&
                            ` • ${item.size}`}

                        </div>

                      )}

                    </div>

                  </div>

                  <div className="checkout-product-price">

                    ₹

                    {item.productType === "SALE"
                      ? (
                          Number(item.price) *
                          Number(item.quantity)
                        ).toLocaleString()
                      : (
                          Number(item.dailyPrice) *
                          Number(item.quantity) *
                          Number(item.days || 1)
                        ).toLocaleString()}

                  </div>

                </div>

              ))}

            </div>

          </div>

          {/* LOCATION PICKER */}

          <LocationPicker
            open={showLocationModal}
            onClose={() => setShowLocationModal(false)}
            initialLocation={
              checkoutData.deliveryLocation
                ? {
                    ...checkoutData.deliveryLocation,
                    lat:
                      checkoutData.deliveryLocation
                        .latitude,
                    lng:
                      checkoutData.deliveryLocation
                        .longitude
                  }
                : null
            }
            onSelect={(location) => {

              setCheckoutData({
                ...checkoutData,
                deliveryLocation: location
              });

              setShowLocationModal(false);

            }}
          />
                    {/* Bottom spacing so content isn't hidden behind sticky footer */}
          <div style={{ height: 100 }} />

        </div>

        {/* ===========================
              STICKY FOOTER
        =========================== */}

        <div className="checkout-footer">

          <div className="checkout-total">

            <div className="checkout-total-label">
              Total Amount
            </div>

            <div className="checkout-total-value">
              ₹{totalAmount.toLocaleString()}
            </div>

          </div>

          <button
    className="checkout-submit-btn"
    onClick={handlePlaceOrder}
    disabled={
        placingOrder ||
        !checkoutData.name ||
        !checkoutData.phone ||
        !checkoutData.deliveryLocation?.address
    }
>

    {placingOrder ? (

        <>
            <span className="checkout-spinner"></span>

            Placing Order...

        </>

    ) : (

        "Proceed to Order"

    )}

</button>

        </div>

      </div>
    </>
  );
}